<template>
      <div class="relative flex-1 px-4 sm:px-6">
        <div class="space-y-4 options">
          <div class="flex justify-between items-start">
            <h2 class="text-base font-semibold tracking-wide md:text-xl text-gray-50">Looks</h2>
            <div @click.prevent="$emit('close')"
             class="px-2 py-1 -mx-2 -my-2 text-white rounded-full cursor-pointer hover:bg-gray-100 hover:text-gray-700 hover:ring-white">
              <i class=" fas fa-chevron-down"></i>
            </div>
          </div>


      <!-- Video thumbnail grid -->
      <ul role="list" class="grid grid-cols-3 gap-x-4 gap-y-4 sm:grid-cols-4 sm:gap-x-6 lg:grid-cols-5 xl:gap-x-8">
        <template v-for="video in videos">
          <li class="relative">
            <div
              @click.prevent="$emit('change', { key: 'video', value: video.id })"
              class="block w-full overflow-hidden rounded-lg group aspect-w-10 aspect-h-7 ring-4 ring-transparent hover:ring-white"
              :class="[
                state.video === video.id
                  ? 'bg-white text-teal-50 ring-white'
                  : 'text-white bg-gray-100 hover:bg-green-300',
              ]">
              <img :src="video.img" :alt="video.title" class="object-cover pointer-events-none group-hover:opacity-75">
              <button type="button" class="absolute inset-0 focus:outline-none">
                <span class="sr-only">Load {{ video.title }}</span>
              </button>
            </div>
            <p class="block mt-2 text-xs sm:text-sm font-medium text-gray-200 truncate pointer-events-none">{{ video.title }}</p>
          </li>
        </template>
      </ul>

      </div>
    </div>
</template>

<script>
export default {
  props: {
    state: {
      type: Object,
      default: null
    }
  },

  data () {
    return  {
      videos: [
        {
            title: 'Video 1',
            id: 'video_1',
            img: '/images/videos/video-01.png'
        },
        {
            title: 'Video 2',
            id: 'video_2',
            img: '/images/videos/video-02.png'
        },
        {
            title: 'Video 3',
            id: 'video_3',
            img: '/images/videos/video-03.png'
        },
        {
            title: 'Video 4',
            id: 'video_4',
            img: '/images/videos/video-04.png'
        },
        {
            title: 'Video 5',
            id: 'video_5',
            img: '/images/videos/video-05.png'
        }
      ]
    }
  }
}
</script>
